import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import Vivus from 'vivus'
import { TimelineMax, Power1 } from 'gsap'

import ParallaxPanel from '../../common/ParallaxPanel'
import TransitionContainer from '../../common/TransitionContainer'
import HomeTopSlideshow from './HomeTopSlideshow'
import Menu from '../../common/menuModal/Menu'
import MenuButton from '../../common/MenuButton'
import HomeSVG from './HomeSVG'

import downArrow from '../../../images/icons/arrow-down.png'

const Wrapper = styled.section`
  position: relative;
  height: 100vh;
  text-align: center;
  min-height: 36em;
  background-size: cover;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .menu-button {
    opacity: 0;
  }

  .home-landing-arrow {
    position: absolute;
    bottom: 1.5em;
    left: 50%;
    margin-left: -1em;
    width: 2em;
    padding: 0.5em;
    opacity: 0;
    transform: translateY(-1em);
    z-index: 2;
  }
`

const Title = styled.div`
  position: relative;
  z-index: 9;
  padding: 25px;
  transition: opacity 0.3s ease;
  width: 100%;
  margin-top: -1em;

  svg {
    width: 80%;
    max-width: 26em;

    & > g {
      transform: translateY(0);
      opacity: 1;
      transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1),
        opacity 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    & > g:nth-child(2) {
      transition-delay: 0.1s;
    }

    & > g:nth-child(3) {
      transition-delay: 0.2s;
    }
  }

  button {
    font-size: 1em;
    background-color: ${props => props.theme.secondary.bg2};
    border-color: ${props => props.theme.secondary.bg2};
    opacity: 0.9;

    &:hover {
      opacity: 1;
    }
  }

  svg.hidden > g,
  button {
    transform: translateY(60px);
    opacity: 0;
  }

  &.hidden {
    opacity: 0;
  }

  @media screen and (min-width: 801px) {
    svg {
      width: 50%;
    }
  }
`

let shown = false

export default function HomeTop({ slides, ready, mobile, windowWidth }) {
  const [menuToggled, setMenuToggled] = useState(false)
  const [titleVisible, setTitleVisible] = useState(false)
  const vivus = useRef(null)

  useEffect(() => {
    vivus.current = new Vivus(
      'welcome-svg',
      { duration: shown ? 20 : 50, start: shown ? undefined : 'manual', delay: shown ? 0 : 15 },
      showArrow
    )

    if (shown && !titleVisible) {
      showTitle(0)
    }
  }, [])

  useEffect(() => {
    if (ready && !shown) {
      showTitle()
    }
  }, [ready, shown])

  function showArrow() {
    const tl = new TimelineMax()

    tl.to('.home-landing-arrow', 1.2, {
      delay: 0.6,
      autoAlpha: 0.7,
      y: 0,
      ease: Power1.easeInOut,
    })
      .to('.home-landing-arrow', 1.2, { y: -10, ease: Power1.easeInOut })
      .to('.home-landing-arrow', 1.2, { y: 0, ease: Power1.easeInOut })
      .to('.home-landing-arrow', 1.2, { y: -10, ease: Power1.easeInOut })
      .to('.home-landing-arrow', 1.2, { y: 0, ease: Power1.easeInOut })
  }

  function showTitle(delay = 50) {
    setTitleVisible(true)
    shown = true

    setTimeout(() => {
      vivus.current.play()
    }, delay)
  }

  return (
    <Wrapper>
      <ParallaxPanel reset={titleVisible} mobile={mobile}>
        <HomeTopSlideshow slides={slides} start={ready} />
      </ParallaxPanel>
      <TransitionGroup component={TransitionContainer}>{menuToggled && <Menu />}</TransitionGroup>
      <MenuButton
        onClick={() => setMenuToggled(prev => !prev)}
        style={{ opacity: titleVisible ? 1 : 0 }}
        toggled={menuToggled}
      />
      <img className="home-landing-arrow" src={downArrow} alt="scroll down" />
      <Title>
        <div>
          <HomeSVG className={titleVisible ? '' : 'hidden'} />
        </div>
      </Title>
    </Wrapper>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/home/HomeTop.js